var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 30,
    fill: "none",
    viewBox: "0 0 65 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentcolor",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65 5.389 60.352.769l-6.958 6.923L46.43.769l-4.64 4.62 6.964 6.922-6.964 6.923 4.64 4.613 6.965-6.923 6.958 6.923L65 19.234l-6.965-6.923z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.099 11.535-4.641-4.612-6.965 6.922-6.965-6.922-4.64 4.612 6.964 6.93-6.964 6.922L25.528 30l6.965-6.922L39.458 30l4.641-4.613-6.965-6.922z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.211 5.382 18.571.77l-6.965 6.923L4.64.769 0 5.382l6.965 6.923L0 19.227l4.64 4.62 6.966-6.923 6.964 6.923 4.641-4.62-6.964-6.922z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M0 0h65v30H0z"
  })))));
};
export default SvgLogo;